import type { Fetcher } from "../fetcher";
import type { ReferenceProfile } from "../entities/reference";
import type { ApiSingleResponse } from "../types/api";

/**
 * Repository for shared reference data.
 *
 * Returns the wire shape directly. The backend resolves localised reference
 * names server-side via the `X-Language` header, so the client just consumes
 * the resolved `name` strings without further mapping.
 */
export function createReferencesRepository(fetcher: Fetcher) {
  return {
    /**
     * Get a reference profile (e.g. `quote-create`, `vehicle-create`,
     * `driver-create`). The backend route is `/reference?profile=<name>`.
     */
    getProfile: async (profileName: string): Promise<ReferenceProfile> => {
      const res = await fetcher<ApiSingleResponse<ReferenceProfile>>(
        `/reference?profile=${profileName}`,
      );
      return res.data ?? {};
    },
  };
}
